module.exports = __webpack_public_path__ + "static/media/14.Crown 2.34d20cec.gif";